import React, { } from 'react';

import styled from 'styled-components';

import LocalStorageHelper from "../../Utilities/Helpers/LocalStorageHelper";

import { ColorEnum } from '../../Utilities/Enums/ColorEnums';

type CustomStatusInterface = {
    colorType?: ColorEnum;
    label?: string;
};

type StatusColorTypes = { [K in ColorEnum]: {
    backgroundColor: string,
    textColor: string,
    hoverBackgroundColor: string,
    hoverTextColor: string,
} };

const StatusColors: StatusColorTypes = {
    [ColorEnum.GREEN]: {
        backgroundColor: "#d9f5f0 !important",
        textColor: "#00bd9d !important",
        hoverBackgroundColor: "#00bd9d26 !important",
        hoverTextColor: "#00bd9d !important",
    },
    [ColorEnum.RED]: {
        backgroundColor: "#fde8e4 !important",
        textColor: "#f06548 !important",
        hoverBackgroundColor: "#f0654826 !important",
        hoverTextColor: "#f06548 !important",
    },
    [ColorEnum.YELLOW]: {
        backgroundColor: "#fff5da !important",
        textColor: "#ffbc0a !important",
        hoverBackgroundColor: "#ffbc0a26 !important",
        hoverTextColor: "#ffbc0a !important",
    },
    [ColorEnum.BLUE]: {
        backgroundColor: "#e0f7ff !important",
        textColor: "#25a0e2 !important",
        hoverBackgroundColor: "#32ccff26 !important",
        hoverTextColor: "#25a0e2 !important",
    },
    [ColorEnum.GRAY]: {
        backgroundColor: 'transparent',
        textColor: "var(--textCancelColor) !important",
        hoverBackgroundColor: "var(----fieldThumbTracksBGPrimaryColor) !important",
        hoverTextColor: "var(--textCancelColor) !important",
    },
}

const StyledStatusContainer: any = styled.div <{
    $colorType: ColorEnum,
    $isdarkmode: boolean,
}>`
    background: ${(props) => (props.$isdarkmode ? StatusColors[props.$colorType].hoverBackgroundColor : StatusColors[props.$colorType].backgroundColor)};
    width: max-content;
    padding: 2px 10px;
    border-radius: 20px;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => (props.$isdarkmode ? StatusColors[props.$colorType].hoverTextColor : StatusColors[props.$colorType].textColor)};
`;

const CustomStatus = (fieldProps: CustomStatusInterface) => {
    let isDarkMode = LocalStorageHelper.isDarkMode();

    if (!fieldProps?.label) {
        return <></>
    }
	return <StyledStatusContainer $colorType={fieldProps?.colorType ?? 0} $isdarkmode={isDarkMode}>{fieldProps?.label ?? ""}</StyledStatusContainer>
}

export default CustomStatus;